var exports = {
  "w": "logo__TJShAe",
  "S": "image__lgVVzC",
};

module.exports = exports;
